import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { UnavailabilityError } from '@unimodules/core';
import ExpoImageManipulator from "./ExpoImageManipulator";
import { SaveFormat } from "./ImageManipulator.types";
export function manipulateAsync(uri) {
  var actions,
      _ref,
      _ref$format,
      format,
      rest,
      _args = arguments;

  return _regeneratorRuntime.async(function manipulateAsync$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          actions = _args.length > 1 && _args[1] !== undefined ? _args[1] : [];
          _ref = _args.length > 2 && _args[2] !== undefined ? _args[2] : {}, _ref$format = _ref.format, format = _ref$format === void 0 ? SaveFormat.JPEG : _ref$format, rest = _objectWithoutProperties(_ref, ["format"]);

          if (ExpoImageManipulator.manipulateAsync) {
            _context.next = 4;
            break;
          }

          throw new UnavailabilityError('ImageManipulator', 'manipulateAsync');

        case 4:
          if (typeof uri === 'string') {
            _context.next = 6;
            break;
          }

          throw new TypeError('The "uri" argument must be a string');

        case 6:
          _context.next = 8;
          return _regeneratorRuntime.awrap(ExpoImageManipulator.manipulateAsync(uri, actions, _objectSpread({
            format: format
          }, rest)));

        case 8:
          return _context.abrupt("return", _context.sent);

        case 9:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, null, Promise);
}
export * from "./ImageManipulator.types";